import React, { useEffect, useState } from "react";

import { Image, Upload } from "antd";
import ImgCrop from "antd-img-crop";
import { FaCloudUploadAlt, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";

import { assetRemove, assetUpload } from "../../services/assets";
import { IMAGE_URL } from "../../config/config";

const ImageUpload = ({
  aspectRatio,
  image,
  setFieldValue,
  name,
  placeholder,
  errors,
  touched,
}) => {
  const [fileList, setFileList] = useState([]);

  const props = {
    beforeUpload: (file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        const inputs = {
          file: reader.result,
        };
        const isJpgOrPng =
          file.type === "image/jpeg" || file.type === "image/png";
        if (!isJpgOrPng) {
          toast.error("You can only upload JPG/PNG file!");
          return isJpgOrPng;
        }
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
          toast.error("Image must smaller than 2MB!");
          return isLt5M;
        }

        const res = await assetUpload(inputs);
        setFileList((prev) => [
          ...prev,
          { url: reader.result, status: "uploading" },
        ]);
        if (res?.status === 201) {
          setFileList((prev) => [{ url: prev[0].url, status: "success" }]);
          toast.success(res?.data?.message);
          setFieldValue(name, res?.data?.url);
        } else {
          toast.error(res?.data?.message);
          setFileList((prev) => [{ url: prev[0].url, status: "error" }]);
        }
      };
      return false;
    },
    fileList,
  };

  const getSrcFromFile = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => resolve(reader.result);
    });
  };

  const onRemove = async () => {
    const res = await assetRemove({ file: image });
    if (res?.status === 200) {
      setFileList([]);
      toast?.success(res?.data?.message);
      setFieldValue("image", "");
    } else {
      toast.error(res?.data?.message);
    }
  };

  const onPreview = async (file) => {
    const src = file.url || (await getSrcFromFile(file));
    const imgWindow = window.open(src);
    if (imgWindow) {
      const image = new Image();
      image.src = src;
      imgWindow.document.write(image.outerHTML);
    } else {
      window.location.href = src;
    }
  };

  useEffect(() => {
    if (image === "") {
      setFileList([]);
    }
  }, [image]);

  return image !== "" ? (
    <div className="relative">
      <Image width={"100%"} src={`${IMAGE_URL}${image}`} preview={false} />
      <div
        className=" absolute top-0 right-0 w-10 h-10 bg-white/50 flex items-center justify-center cursor-pointer"
        onClick={onRemove}
      >
        <FaTrash className="text-2xl text-red-500" />
      </div>
    </div>
  ) : (
    <ImgCrop aspect={aspectRatio} grid rotate>
      <Upload
        beforeUpload={props.beforeUpload}
        listType="picture"
        fileList={fileList}
        onRemove={onRemove}
        maxCount={1}
        onPreview={onPreview}
        className={`list-inline ${
          fileList.length !== 1 ? "flex flex-1 justify-stretch w-full" : ""
        }`}
      >
        {fileList.length < 1 && (
          <div className=" w-full flex items-center justify-center flex-col  border border-gray-300 rounded-lg py-4">
            <p className=" font-Nunito font-medium text-sm text-gray-400 pb-2">
              {placeholder}
            </p>
            <FaCloudUploadAlt className="text-4xl text-gray-500" />
            {errors.image && touched.image && (
              <p className="text-red-500 py-1  text-xs font-Nunito font-normal pt-4">
                {errors.image}
              </p>
            )}
          </div>
        )}
      </Upload>
    </ImgCrop>
  );
};

export default ImageUpload;
